import React, {Component} from 'react'
import StyleSheet from 'styles'
import QRCode from 'qrcode.react'
import ConfirmationDialog from 'components/ConfirmationDialog'
import ReactDOM from 'react-dom'

export class CryptoInvest extends Component {
  state = {
    addressOpen: false
  }

  addressRefHandler = (reactNode) => {
    this.addressDomNode = reactNode && ReactDOM.findDOMNode(reactNode)
  }

  copyAddress = () => {
    this.addressDomNode.select()
    document.execCommand("copy")
  }

  closeAddress = () => {
    this.setState({addressOpen: false})
  }

  render() {
    const {allocation} = this.props
    return (
      <div>
        <div className={styles.qrContainer}>
          <QRCode className="test" value={allocation.paymentQrcode} size={64}/>
        </div>
        <dl style={{paddingTop: 35}}>
          <dt>Deposit Address</dt>
          <dd className={styles.address} onClick={() => this.setState({addressOpen: true})}>
            {allocation.depositAddress}
          </dd>
        </dl>
        <ConfirmationDialog
          onConfirm={this.copyAddress}
          onCancel={this.closeAddress}
          title="Deposit Address"
          open={this.state.addressOpen}
          canCancel canConfirm cancelLabel="Close" confirmLabel="Copy"
        >
          <input className={styles.addressInput} type="text" value={allocation.depositAddress} ref={this.addressRefHandler} readOnly/>
        </ConfirmationDialog>
      </div>
    )
  }
}

const styles = StyleSheet({
  qrContainer: {
    position: 'absolute',
    right: 10,
    top: 10,
    width: 64,
    padding: '9px 9px 5px 9px',
    backgroundColor: '#FFF'
  },
  address: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  },
  addressInput: {
    border: 'none',
    background: 'transparent',
    color: 'white',
    fontSize: '14px',
  }
})
